<template>
  <div v-if="winemakers" class="col-sm-6">
    <div class="box">
      <div class="box-header">
        <h2 class="box-title">Winemakers</h2>
      </div>
      <div class="box-body">
        <div class="form-group">
          <ul class="list-remove">
            <li v-for="winemaker in winemakers">{{winemaker.name}}<a @click.prevent="remove(winemaker, $index)" class="region-delete btn btn-sm"><i class="fa fa-close"></i> Delete</a></li>
            <li v-if="!winemakers.length && !loading">No winemakers.</li>
            <li v-if="!winemakers.length && loading">Loading winemakers...</li>
          </ul>
        </div>
        <form @submit.prevent="save">
          <div class="input-group">
            <input type="text" v-model="name" class="form-control">
            <span class="input-group-btn">
              <button class="btn btn-default"><i class="fa fa-plus"></i> Add Winemaker</button>
            </span>
          </div>
          </form
        </div>
      </div>
    </div>
</template>

<script>
  import Http from 'utils/http';
  import Notify from 'utils/notify';
  import Alert from 'utils/alert';
  import { toConsole } from 'utils/logger';

  export default {
    props: ['winemakers', 'loading', 'site'],

    data() {
      return {
        api: 'winemakers',
        name: null
      }
    },

    methods: {
      save() {
        Http.post(this.api, { name: this.name, site_id: this.site.id }).then(response => {
          Notify.success(`New winemaker added.`);
          this.winemakers.push(response.body.winemaker);
          this.name = null;
        }, response => {
          toConsole(response);
          Notify.warning('Winemaker could not be added.')
        });
      },

      remove(winemaker, index) {
        const api = this.api;

        Alert.delete({
          showLoaderOnConfirm: true,
          preConfirm() {
            return Http.destroy(`${api}/${winemaker.id}`);
          }
        }).then(() => {
          Alert.success({ text: 'Winemaker has been deleted.' }).then(() => {}, () => {});
          this.winemakers.splice(index, 1);
        }, () => {});
      }
    }
  }
</script>



// WEBPACK FOOTER //
// winemakers.vue?6a64b376